import { useState } from "react";
import { Link } from "react-router-dom";

export default function FinancialReportsPage() {
  const [dateRange, setDateRange] = useState("today");

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-xl font-bold text-foreground-950">Finansal Raporlar</h1>
          <p className="text-sm text-foreground-500 mt-0.5">
            Gelir, gider ve kârlılık analizleri
          </p>
        </div>
        <div className="flex items-center gap-2">
          <select
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value)}
            className="px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-700 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
          >
            <option value="today">Bugün</option>
            <option value="week">Bu Hafta</option>
            <option value="month">Bu Ay</option>
            <option value="quarter">Bu Çeyrek</option>
            <option value="year">Bu Yıl</option>
          </select>
          <button className="flex items-center gap-1.5 px-3 py-2 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-download-2-line"></i>
            <span className="hidden sm:inline">İndir</span>
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
              <i className="ri-money-dollar-circle-line text-primary-600 text-lg"></i>
            </div>
            <span className="text-sm text-foreground-500">Toplam Gelir</span>
          </div>
          <p className="text-2xl font-bold text-foreground-950">$124,560.00</p>
          <p className="text-xs text-primary-600 mt-1">+12.5% geçen döneme göre</p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
              <i className="ri-arrow-down-circle-line text-accent-600 text-lg"></i>
            </div>
            <span className="text-sm text-foreground-500">Toplam Gider</span>
          </div>
          <p className="text-2xl font-bold text-foreground-950">$45,230.00</p>
          <p className="text-xs text-accent-600 mt-1">+5.2% geçen döneme göre</p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center">
              <i className="ri-line-chart-line text-secondary-600 text-lg"></i>
            </div>
            <span className="text-sm text-foreground-500">Net Kâr</span>
          </div>
          <p className="text-2xl font-bold text-foreground-950">$79,330.00</p>
          <p className="text-xs text-secondary-600 mt-1">Kâr marjı: %63.7</p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 rounded-lg bg-background-100 flex items-center justify-center">
              <i className="ri-bank-line text-foreground-500 text-lg"></i>
            </div>
            <span className="text-sm text-foreground-500">Tahsilat</span>
          </div>
          <p className="text-2xl font-bold text-foreground-950">$98,450.00</p>
          <p className="text-xs text-foreground-500 mt-1">Tahsilat oranı: %79.1</p>
        </div>
      </div>

      {/* Placeholder Charts */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <h3 className="text-sm font-semibold text-foreground-950 mb-4">Gelir - Gider Trendi</h3>
          <div className="h-48 flex items-end justify-around gap-2">
            {[65, 48, 72, 55, 80, 62, 75, 58, 85, 70, 90, 78].map((h, i) => (
              <div key={i} className="flex flex-col items-center gap-1 flex-1">
                <div className="w-full flex gap-0.5 items-end h-36">
                  <div className="flex-1 bg-primary-400/80 rounded-t-sm" style={{ height: `${h}%` }}></div>
                  <div className="flex-1 bg-accent-400/60 rounded-t-sm" style={{ height: `${Math.max(h - 20, 10)}%` }}></div>
                </div>
                <span className="text-[10px] text-foreground-400">{i + 1}</span>
              </div>
            ))}
          </div>
          <div className="flex items-center justify-center gap-4 mt-3">
            <div className="flex items-center gap-1.5">
              <div className="w-3 h-3 bg-primary-400/80 rounded-sm"></div>
              <span className="text-xs text-foreground-500">Gelir</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-3 h-3 bg-accent-400/60 rounded-sm"></div>
              <span className="text-xs text-foreground-500">Gider</span>
            </div>
          </div>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <h3 className="text-sm font-semibold text-foreground-950 mb-4">Ödeme Yöntemleri Dağılımı</h3>
          <div className="flex items-center justify-center h-48">
            <div className="relative w-40 h-40">
              <svg viewBox="0 0 36 36" className="w-full h-full -rotate-90">
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="oklch(var(--primary-300))" strokeWidth="3" strokeDasharray="45 55" />
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="oklch(var(--accent-300))" strokeWidth="3" strokeDasharray="30 70" strokeDashoffset="-45" />
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="oklch(var(--secondary-300))" strokeWidth="3" strokeDasharray="15 85" strokeDashoffset="-75" />
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="oklch(var(--foreground-300))" strokeWidth="3" strokeDasharray="10 90" strokeDashoffset="-90" />
              </svg>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-2 mt-2">
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded-full bg-primary-300"></div><span className="text-xs text-foreground-500">Nakit %45</span></div>
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded-full bg-accent-300"></div><span className="text-xs text-foreground-500">K.Kartı %30</span></div>
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded-full bg-secondary-300"></div><span className="text-xs text-foreground-500">Havale %15</span></div>
            <div className="flex items-center gap-1.5"><div className="w-2.5 h-2.5 rounded-full bg-foreground-300"></div><span className="text-xs text-foreground-500">Çek %10</span></div>
          </div>
        </div>
      </div>

      {/* Back to reports */}
      <div className="flex justify-start">
        <Link
          to="/reports/sales-purchases"
          className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line"></i>
          Satış - Alış Raporlarına Dön
        </Link>
      </div>
    </div>
  );
}